import { Outlet } from 'react-router-dom';
import { Navbar } from '@/components/abogados/Navbar';
import { AbogadosFooter } from '@/components/abogados/AbogadosFooter';
import { StickyMobileCTA } from '@/components/abogados/StickyMobileCTA';
import { useHashScroll } from '@/hooks/useHashScroll';

/**
 * Layout compartido del sitio `/abogados/*`.
 *
 * - Es eager (no lazy) para evitar parpadeo del navbar/footer entre navegaciones.
 * - Cada página hija (`HomePage`, `PlanesComparativa`, etc.) sí es lazy.
 * - `useHashScroll` preserva los deep-links históricos (`#pricing`, `#faq`, …).
 */
export function AbogadosLayout() {
  useHashScroll();

  return (
    <div className="min-h-screen bg-[#0F172A] font-sans antialiased">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <AbogadosFooter />
      <StickyMobileCTA />
    </div>
  );
}

export default AbogadosLayout;
